import { Component, OnInit } from '@angular/core';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-support-documents',
  templateUrl: './support-documents.component.html',
  styleUrls: ['./support-documents.component.scss'],
})
export class SupportDocumentsComponent implements OnInit {

  options: [any];
  screenCopies: any;
  documents: any;
  productsMulti: any[] = [];
  occupation: any;
  hasLoanProduct: any;
  typeOfLoan: any;
  mainButtonBehaviour = {
    previous: false,
    next: true,
    label: 'volver',
  };

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private taggingService: TaggingService) {
    this.headerService.show(false, true, true);
    this.screenCopies = {};
  }

  ngOnInit() {
    this.sendTagging();
    this.screenCopies = this.copyService.copies.support_documents;
    // this.options = this.abreCuentasService.getBusinessConfig(OpEnum.REVOLVING_CREDIT_SOPPORT_DOCUMENTS);
    const occupation = this.abreCuentasService.getOccupationSelected();
    // productsMulti -> get list of multiproduct
    this.productsMulti = this.abreCuentasService.getProductsSelects();
    this.hasLoanProduct = this.abreCuentasService.getLoanSelected();
    this.typeOfLoan = this.abreCuentasService.getRequestLoanSelected();
    this.occupation = occupation.name.toLowerCase() + 's';
    this.setDocumentScreenInfo(occupation);
    this.setMainButton();
  }

  setDocumentScreenInfo(occupation) {
    console.log('credito seleccionado: ', this.typeOfLoan);
    this.screenCopies.titleConector = 'para';
    switch (occupation.id) {
      case 1:
        this.screenCopies.titleConector = 'de';
        if (this.productsMulti.length !== 0 && this.hasLoanProduct) {
          if (this.typeOfLoan.elementId === '01') {
            this.documents = [
              this.screenCopies.voucher_last_two_months,
              this.screenCopies.working_letter,
              this.screenCopies.salary_certificade,
            ];
          } else {
            this.documents = [
              this.screenCopies.voucher_last_two_months,
              this.screenCopies.debt_certificade,
              this.screenCopies.working_letter,
              this.screenCopies.salary_certificade,
            ];
          }
        } else {
          this.documents = [
            this.screenCopies.working_letter,
            this.screenCopies.salary_certificade,
            this.screenCopies.last_monhtly_payment_optional,
          ];
        }
        break;
      case 2:
        if (this.abreCuentasService.getCiiuSelected().ciiu === '090') {
          this.occupation = 'rentistas de capital',
            this.documents = [
              this.screenCopies.voucher_last_three_months,
              this.screenCopies.salary_certificade_lastyear_taxable,
            ];
        } else {
          this.documents = [
            this.screenCopies.income_statement,
            this.screenCopies.voucher_last_three_months,
            this.screenCopies.salary_certificade_lastyear_taxable,
          ];
        }
        break;
      case 5:
        if (this.productsMulti.length !== 0 && this.hasLoanProduct) {
          if (this.typeOfLoan.elementId === '01') {
            this.documents = [
              this.screenCopies.voucher_last_two_months,
              this.screenCopies.income_statement,
              this.screenCopies.salary_certificade,
              this.screenCopies.voucher_last_three_months_optional,
            ];
          } else {
            this.documents = [
              this.screenCopies.voucher_last_two_months,
              this.screenCopies.debt_certificade,
              this.screenCopies.income_statement,
              this.screenCopies.salary_certificade,
              this.screenCopies.voucher_last_three_months_optional,
            ];
          }
        } else {
          this.documents = [
            this.screenCopies.last_monthly_payment,
            this.screenCopies.salary_certificade,
            this.screenCopies.income_statement,
            this.screenCopies.voucher_last_three_months_optional,
          ];
        }
        break;
      default:
        break;
    }
  }

  // Summary Go to next Step

  next() {
    if (this.productsMulti.length !== 0) {
      this.navigationService.nextStep('200');
    } else {
      this.navigationService.nextStep('200');
    }
  }

  setMainButton() {
    const w = window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;
    if (w < 1024) {
      return;
    }
    this.mainButtonBehaviour = {
      previous: false,
      next: true,
      label: 'volver',
    };
  }

  sendTagging() {
    const page = '11';
    const extras = {
      pageValue: 'SupportDocuments',
    };
    this.taggingService.sendTaggValues('init', page, '', '', extras);
  }

}
